import React from 'react';
import Textarea from '../../../../components/Textarea';
import KeyPickupDocuments from '../../KeyPickupDocuments';
import SectionHeading from 'src/components/SectionHeading/SectionHeading';
import './key-handoff-documents-and-notes.scss';

interface KeyHandoffDocumentsAndNotesProps {
  importantDocuments: any[];
  user: any;
  notes: string;
  onChangeNotes: (value: string) => void;
}

const KeyHandoffDocumentsAndNotes = ({
  importantDocuments,
  user,
  notes,
  onChangeNotes,
}: KeyHandoffDocumentsAndNotesProps) => {
  const hasDocuments: boolean =
    Array.isArray(importantDocuments) && importantDocuments.length > 0;

  return (<div className="key-handoff-documents-and-notes">
      <div className="documents-notes-panel">
        <SectionHeading title="Documents & Notes" />
        {hasDocuments && (
          <KeyPickupDocuments
            importantDocuments={importantDocuments}
            user={user}
          />
        )}

        <Textarea
          value={notes}
          onChange={(e: any) => onChangeNotes(e?.target?.value ?? '')}
          label="Notes"
          placeholder="Add any notes for this key pickup"
          block
        />
      </div>
    </div>
  );
};

export default KeyHandoffDocumentsAndNotes;